module.exports = __webpack_public_path__ + "static/media/merntask.56ef1e09.gif";